import * as React from 'react';
import {Tooltip} from 'antd';
import {ExclamationOutlined} from '@ant-design/icons';

interface InfoIconProps {
  message: string;
}

export const ExclamationIcon = ({message}: InfoIconProps) => (
  <Tooltip title={message}>
    <ExclamationOutlined style={{color: '#e0a901'}} type="exclamation" />
  </Tooltip>
);
